var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChanges(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.347 11H25.6945C24.7584 11 24 11.7871 24 12.7581C24 13.729 24.7584 14.5161 25.6945 14.5161H26.8235V89H29.218V14.5161H30.347C31.2826 14.5161 32.0415 13.729 32.0415 12.7581C32.0415 11.7871 31.283 11 30.347 11Z",
    fill: "#004AAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0001 44.6101C61.8323 33.151 46.6649 56.0693 31.4976 44.6101C31.4976 35.0609 31.4976 25.5117 31.4976 15.962C46.6649 27.4212 61.8323 4.50288 77.0001 15.962C77.0001 25.5117 77.0001 35.0609 77.0001 44.6101Z",
    fill: "#004AAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChanges);
export default __webpack_public_path__ + "static/media/changes.ce2f9715d3ba8ca58e8bcede23f582e8.svg";
export { ForwardRef as ReactComponent };